<template>
  <div>
    <van-popup v-model="show" round position="bottom" class="couponsList">
      <div class="van-coupon-list">
        <div class="van-tabs__content">
          <div role="tabpanel" class="van-tab__pane" style="">
            <div
              class="van-coupon-list__list van-coupon-list__list--with-bottom"
            >
              <van-checkbox-group
                v-model="couponsChecked"
                ref="checkboxGroup"
                @change="changeCheckboxes"
              >
                <div
                  class="van-coupon"
                  v-for="(item, index) in couponsList"
                  :key="index"
                  @click="couponsClick(index)"
                >
                  <div class="van-coupon__content">
                    <div class="van-coupon__head">
                      <van-icon class="iconfont iconqiaquanguanli" size="32" />
                    </div>
                    <div class="van-coupon__body">
                      <p class="van-coupon__name">
                        {{ item.couponsProductName }}
                      </p>
                      <p class="van-coupon__valid">
                        <span>到期时间：{{ item.couponsEndDate }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="van-coupon__description">
                    <div class="left">
                      <p class="money">
                        余额
                        <span style="font-weight: 700; font-size: 16px">￥</span
                        ><span class="number">{{
                          $formatMoney(Number(item.couponsBalance), 2).split(
                            "."
                          )[0]
                        }}</span
                        ><span style="font-weight: 700; font-size: 18px"
                          >.{{
                            $formatMoney(Number(item.couponsBalance), 2).split(
                              "."
                            )[1]
                          }}</span
                        >
                      </p>
                      <!-- <p class="remark">备注：说明XXXXXXXX</p> -->
                    </div>
                    <div class="right">
                      <van-checkbox
                        checked-color="#f90"
                        ref="checkboxes"
                        :name="item"
                        :disabled="item.couponsStatus == 0"
                      ></van-checkbox>
                    </div>
                  </div>
                </div>
              </van-checkbox-group>
            </div>
          </div>
        </div>
        <div class="van-coupon-list__bottom" style="position: fixed">
          <button
            class="
              van-button
              van-button--danger
              van-button--normal
              van-button--block
              van-button--round
              van-coupon-list__close
            "
            @click="confirm"
          >
            <div class="van-button__content">
              <span class="van-button__text">确定</span>
            </div>
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  props: {
    couponsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      price: 0,
      couponsDeduct: 0,
      couponIds: [],
      couponsChecked: [],
    };
  },
  methods: {
    open(price) {
      if (price) {
        this.price = price;
      } else {
        this.price = 0;
      }
      this.show = true;
    },
    changeCheckboxes(names) {
      let money = 0;
      names.forEach((element) => {
        money += Number(element.couponsBalance);
      });
      this.couponIds = names.map((element) => {
        return element.couponsId;
      });

      let remainder = this.price - money;
      remainder = remainder > 0 ? money : this.price;
      this.couponsDeduct = Number(remainder >= 0 ? remainder : 0);
    },
    couponsClick(index) {
      let checkBox = this.$refs.checkboxes[index];
      if (this.price <= 0) {
        this.$error("系统繁忙，请稍后再试");
        checkBox.toggle(false);
        this.show = false;
        return;
      }
      let sum = 0;
      for (let index = 0; index < this.couponsChecked.length; index++) {
        const element = this.couponsChecked[index];
        sum += Number(element.couponsBalance);
      }
      if (sum >= this.price && !checkBox.checked) {
        this.$error("当前已满足支付金额");
        checkBox.toggle(false);
      } else {
        checkBox.toggle();
      }
    },
    confirm() {
      let data = {
        couponsDeduct: this.couponsDeduct,
        count: this.couponsChecked.length,
        couponIds: this.couponIds,
      };
      this.$emit("confirm", data);
      this.show = false;
    },
  },
};
</script>

<style lang="less" scoped>
.couponsList {
  height: 65%;
  background-color: rgb(247, 248, 250);
  .van-coupon-list__list {
    overflow-y: initial;
  }
  .van-coupon {
    border: 2px solid #ff9900;
    .van-coupon__content {
      background-image: linear-gradient(-90deg, #fceabb, #f8b500);
      color: #fff;
      min-height: initial;
      padding: 10px 0;
      .van-coupon__head {
        min-width: initial;
        padding: 0 15px;
      }
    }
    .van-coupon__body {
      .van-coupon__valid {
        display: flex;
        justify-content: space-between;
        margin-right: 15px;
      }
      .van-coupon__name {
        margin-bottom: 5px;
      }
    }
    .van-coupon__description {
      padding: 15px;
      border-top: initial;
      display: flex;
      justify-content: space-between;
      .left {
        width: 90%;
        text-align: center;
        line-height: 1.5;
        .money {
          color: red;
          font-size: 14px;
          .number {
            font-size: 30px;
            font-weight: 700;
          }
        }
        .remark {
          font-size: 14px;
          color: #ccc;
        }
      }
      .right {
        display: flex;
        align-items: center;
        /deep/
          .van-checkbox__icon--disabled.van-checkbox__icon--checked
          .van-icon {
          color: #fff;
          background: #f90;
          border-color: #f90;
        }
        /deep/ .van-checkbox__icon--disabled .van-icon {
          background-color: #ddd;
          border-color: #ddd;
        }
      }
    }
  }
}
</style>